import {
  Component,
} from "react";
import {
  Button,
  ListGroup,
  ListGroupItem,
  Modal,
} from "react-bootstrap";

export default class ErrorReporter extends Component {
  constructor() {
    super();
    this.state = {
      errors: [],
      isOpen: false,
      mayOpen: true,
    };
  }

  componentDidMount() {
    window.onerror = this.onError;
  }

  componentWillUnmount() {
    window.onerror = undefined;
  }

  render() {
    const { isOpen, errors } = this.state;
    return <Modal show={isOpen} onHide={this.close}>
      <Modal.Body>
        <ListGroup style={{ overflowY: "auto", maxHeight: "80vh" }}>
          {errors.map((err, i) => <ListGroupItem key={i}>{err}</ListGroupItem>)}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-primary' onClick={this.closeForever}>Schließen und nicht mehr zeigen</Button>
        <Button variant='primary' onClick={this.close}>Schließen</Button>
      </Modal.Footer>
    </Modal>;
  }

  close = () => {
    this.setState({ isOpen: false });
  };

  closeForever = () => {
    this.setState({ isOpen: false, mayOpen: false });
  };

  onError = (msg, url, lineNo, columnNo, error) => {
    const string = msg.toLowerCase();
    const substring = "script error";
    let message;
    if (string.indexOf(substring) > -1) {
      message = "Script Error: See Browser Console for Detail";
    } else {
      message = error
? error.stack
: [
  "Message: " + msg,
  "URL: " + url,
  "Line: " + lineNo,
  "Column: " + columnNo,
].join(" - ");
    }

    const { errors, mayOpen } = this.state;
    errors.push(message);

    this.setState({ errors, isOpen: mayOpen });
  };
}
